














































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppliedLessonType } from '@/enums/AppliedLessonType';
import { hideModal } from '@/helpers/modal';
import { isDesktop } from '@/helpers/isDesktop';
import type { Worksheet } from '@/models/worksheet';
import { Getter } from 'vuex-class';
import type { Project } from '@/models/project';
import { showErrorNotification } from '@/helpers/showErrorNotification';
import type { PMSubPhase } from '@/models/pmsubphase';
import { ValidationResult } from '@/helpers/validation/Validator';
import FormError from '@/components/utils/FormError.vue';
import { pmAppliedLessonWebservice } from '@/webservices/pmappliedlesson';
import { appliedLessonWebservice } from '@/webservices/appliedlesson';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';
import type { AppliedLesson } from '@/models/appliedlesson';
import { showSuccessNotification } from '@/helpers/showSuccessNotification';
import type { Lesson } from '@/models/lesson';
import type { CompanySetting } from '@/models/companySetting';
import { CombinedUser, getCombinedProjectUsers } from '@/helpers/getCombinedProjectUsers';
import FormTopicPicker from '@/components/form/FormTopicPicker.vue';
import FormSubphasePicker from '@/components/form/FormSubphasePicker.vue';
import FormItem from '@/components/form/FormItem.vue';
import FormProjectUserPicker from '@/components/form/FormProjectUserPicker.vue';
import FormDynamicFieldPicker from '@/components/form/FormDynamicFieldPicker.vue';
import PrineButton from '@/components/prine/PrineButton.vue';
import type { ProjectUser } from '@/models/projectUser';
import ConfirmModal from '@/components/prine/ConfirmModal.vue';
import { xAppliedLessonWebservice } from '@/webservices/xappliedlesson';
import type { XAppliedLesson } from '@/models/xappliedlesson';
import type { XSubProcess } from '@/models/xsubprocess';
import FormSubprocessPicker from '@/components/form/FormSubprocessPicker.vue';
import { validate } from '@/helpers/validation/validate';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { resolveLessonTypeByAppliedLessonType, resolveLessonTypeByLesson } from '@/helpers/resolveLessonType';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'WorksheetUpdateLessonModal',
    components: {
        FormDynamicFieldPicker,
        FormProjectUserPicker,
        FormItem,
        FormSubphasePicker,
        FormSubprocessPicker,
        FormTopicPicker,
        FormError,
        PrineButton,
        ConfirmModal,
    },
})
export default class WorksheetUpdateLessonModal extends Vue {
    get users(): CombinedUser[] {
        return getCombinedProjectUsers(this.selectedProject);
    }
    protected disabled: boolean = false;
    @Prop({
        required: true,
    })
    private type: AppliedLessonType;

    @Prop({
        required: true,
    })
    private worksheet: Worksheet;

    @Prop({
        required: false,
    })
    private saved: (options: {}) => void;

    @Prop({
        required: false,
    })
    private appliedLessonToUpdate;

    private AppliedLessonType = AppliedLessonType;
    private hideModal = hideModal;
    private isDesktop = isDesktop();

    private addToKnowledgeBase = false;
    private projectOnly = false;

    @Getter('account/companySetting') private companySetting: CompanySetting;

    @Getter('utils/currentLocale') private currentLocale: string;
    @Getter('project/selectedProject') private selectedProject: Project;

    private validation: ValidationResult = { success: false, errors: [] };

    private data: {
        insight: string;
        todo: string;
        responsible_user: ProjectUser | null;
        contacttill: Date | null;
        solution: string;
        topic: {};
        sub_phase: PMSubPhase;
        sub_process: XSubProcess;
        dynamic_field: undefined;
    } = {
        insight: '',
        todo: '',
        responsible_user: null,
        contacttill: null,
        solution: '',
        topic: {},
        sub_phase: {} as PMSubPhase,
        sub_process: {} as XSubProcess,
        dynamic_field: undefined,
    };

    private appliedLesson: AppliedLesson | PMAppliedLesson | XAppliedLesson = {} as AppliedLesson;
    private isRemoveConfirmModalActive = false;

    private mounted() {
        if (this.appliedLessonToUpdate) {
            this.appliedLesson = this.appliedLessonToUpdate;
            // applied lessons data
            if (this.type === AppliedLessonType.AppliedLesson) {
                this.data.topic = this.appliedLessonToUpdate.lesson.topics[0];
                this.setVariables();
            } else if (this.type === AppliedLessonType.XAppliedLesson) {
                if (this.appliedLessonToUpdate.hasOwnProperty('lesson')) {
                    this.data.sub_process = this.appliedLessonToUpdate.lesson.x_sub_process;
                    this.setVariables();
                } else {
                    this.data.sub_process = this.appliedLessonToUpdate.x_lesson.x_sub_process;
                    this.data.insight = this.appliedLessonToUpdate.x_lesson.insight;
                    this.addToKnowledgeBase = !this.appliedLessonToUpdate.x_lesson.project_only;
                    this.projectOnly = this.appliedLessonToUpdate.x_lesson.project_only;
                }
            } else {
                if (this.appliedLessonToUpdate.hasOwnProperty('lesson')) {
                    this.data.sub_phase = this.appliedLessonToUpdate.lesson.sub_phase;
                    this.setVariables();
                } else {
                    this.data.sub_phase = this.appliedLessonToUpdate.pm_lesson.sub_phase;
                    this.data.insight = this.appliedLessonToUpdate.pm_lesson.insight;
                    this.addToKnowledgeBase = !this.appliedLessonToUpdate.pm_lesson.project_only;
                    this.projectOnly = this.appliedLessonToUpdate.pm_lesson.project_only;
                }
            }
        }
    }

    get canDelete() {
        return hasPermission(
            resolveLessonTypeByAppliedLessonType(this.type, {
                x: PERMISSIONS.APPEX_X_APPLIED_LESSON_DELETE,
                pm: PERMISSIONS.APPEX_PM_APPLIED_LESSON_DELETE,
                trade: PERMISSIONS.APPEX_APPLIED_LESSON_DELETE,
            })
        );
    }

    private setVariables() {
        this.data.insight = this.appliedLessonToUpdate.lesson.insight;
        this.addToKnowledgeBase = !this.appliedLessonToUpdate.lesson.project_only;
        this.projectOnly = this.appliedLessonToUpdate.lesson.project_only;
    }

    private save() {
        // update applied lesson

        const validations: Record<string, string[]> = {
            insight: ['required', 'string'],
        };

        if (this.type === AppliedLessonType.AppliedLesson) {
            validations.topic = ['required'];
        } else if (this.type === AppliedLessonType.PMAppliedLesson) {
            validations.sub_phase = ['required'];
        } else if (this.type === AppliedLessonType.XAppliedLesson) {
            validations.sub_process = ['required'];
        }

        this.validation = validate(validations, this.data);

        if (!this.validation.success) {
            return false;
        }

        // neutralize time zone
        if (this.appliedLesson.contacttill) {
            this.appliedLesson.contacttill = new Date(
                this.appliedLesson.contacttill.setMinutes(
                    this.appliedLesson.contacttill.getMinutes() - this.appliedLesson.contacttill.getTimezoneOffset()
                )
            );
        }
        switch (this.type) {
            case AppliedLessonType.AppliedLesson:
                appliedLessonWebservice
                    .updateAppliedLessonAndLesson(
                        this.appliedLesson as AppliedLesson,
                        {
                            insight: this.data.insight,
                            project_only: !this.addToKnowledgeBase,
                            topics: this.data.topic,
                        } as Partial<Lesson>
                    )
                    .then(() => {
                        if (this.saved) {
                            this.saved({});
                        }
                        this.lessonsUpdated();
                    })
                    .catch(() => {
                        showErrorNotification('toastMessages.error.worksheet');
                    });
                break;

            case AppliedLessonType.PMAppliedLesson:
                pmAppliedLessonWebservice
                    .updateAppliedLessonAndLesson(this.appliedLesson as PMAppliedLesson, {
                        insight: this.data.insight,
                        project_only: !this.addToKnowledgeBase,
                        sub_phase: this.data.sub_phase,
                    })
                    .then(() => {
                        if (this.saved) {
                            this.saved({});
                        }
                        this.lessonsUpdated();
                    })
                    .catch(() => {
                        showErrorNotification('toastMessages.error.worksheet');
                    });
                break;

            case AppliedLessonType.XAppliedLesson:
                xAppliedLessonWebservice
                    .updateAppliedLessonAndLesson(this.appliedLesson as XAppliedLesson, {
                        insight: this.data.insight,
                        project_only: !this.addToKnowledgeBase,
                        sub_process: this.data.sub_process,
                    })
                    .then(() => {
                        if (this.saved) {
                            this.saved({});
                        }
                        this.lessonsUpdated();
                    })
                    .catch(() => {
                        showErrorNotification('toastMessages.error.worksheet');
                    });
                break;
        }
    }

    private toggleConfirmModal(confirm: boolean) {
        if (confirm) {
            switch (this.type) {
                case AppliedLessonType.AppliedLesson:
                    appliedLessonWebservice
                        .remove(this.appliedLesson.id)
                        .then(() => {
                            hideModal();
                            showSuccessNotification('toastMessages.delete.lesson');
                            if (this.saved) {
                                this.saved({});
                            }
                        })
                        .catch(() => {
                            showErrorNotification('toastMessages.error.lesson');
                        });
                    break;
                case AppliedLessonType.PMAppliedLesson:
                    pmAppliedLessonWebservice
                        .remove(this.appliedLesson.id)
                        .then(() => {
                            hideModal();
                            showSuccessNotification('toastMessages.delete.lesson');
                            if (this.saved) {
                                this.saved({});
                            }
                        })
                        .catch(() => {
                            showErrorNotification('toastMessages.error.lesson');
                        });
                    break;
                case AppliedLessonType.XAppliedLesson:
                    xAppliedLessonWebservice
                        .remove(this.appliedLesson.id)
                        .then(() => {
                            hideModal();
                            showSuccessNotification('toastMessages.delete.lesson');
                            if (this.saved) {
                                this.saved({});
                            }
                        })
                        .catch(() => {
                            showErrorNotification('toastMessages.error.lesson');
                        });
                    break;
            }
        } else {
            this.isRemoveConfirmModalActive = false;
        }
    }

    private lessonsUpdated() {
        hideModal();
        showSuccessNotification('toastMessages.update.lesson');
    }
}
